<template>
  <Modal
    class="refund-dlg"
    v-model="show"
    title="处理退款"
    width="650"
    @on-visible-change="onVisibleChange"
  >
    <Form ref="form" :model="form" :rules="rules" :label-width="90">
      <FormItem label="订单编号：">{{data.order_number}}</FormItem>
      <FormItem label="订单金额：">{{data.order_price}}</FormItem>
      <FormItem label="退款意见：">
        <RadioGroup v-model="form.type" @on-change="onRefundTypeChange">
          <Radio label="2">拒绝</Radio>
          <Radio label="1">同意</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem v-show="form.type==1" label="退款金额：">
        <InputNumber v-model="form.refund_price" style="width:150px;margin-right:15px;"></InputNumber>
      </FormItem>
      <FormItem label="备注信息：" prop="remark">
        <Input
          v-model="form.remark"
          type="textarea"
          :rows="4"
          :placeholder="form.type == 1 ? '请输入备注信息，选填' : '请输入拒绝原因，必填'"
        ></Input>
      </FormItem>
    </Form>
    <div slot="footer" style="text-align:center;">
      <Button type="primary" @click="onOk" size="large" style="width:100px;">确定</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: "refund-dlg",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    const validteRemark = (rule, value, callback) => {
      if (this.form.type != 1 && !value) {
        return callback(new Error("拒绝原因不能为空"));
      }
      callback();
    };
    return {
      show: false,
      form: {
        id: "",
        type: "2",
        refund_price: 0,
        remark: ""
      },
      rules: {
        remark: {
          validator: validteRemark,
          trigger: "blur"
        }
      }
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.show = val;
      }
    },
    show(val) {
      this.$emit("input", val);
    }
  },
  created() {},
  methods: {
    // on event
    onVisibleChange(val) {
      if (val) {
        this.form.id = this.data.refund_id;
        this.form.type = "2";
        this.form.refund_price = +this.data.order_price;
        this.form.remark = "";
      }
    },
    onOk() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.$http.post("/api/refund/auditing", this.form).then(data => {
          if (this.form.type == 2) {
            this.$Message.success("已拒绝退款");
            this.$emit("on-ok");
          } else if (data.res) {
            this.$http
              .post("/api/refund/doAudit", {
                type: 1,
                refund_price: this.form.refund_price,
                id: data.res
              })
              .then(() => {
                this.$Message.success("退款成功");
                this.$emit("on-ok");
              });
          }
        });
        this.show = false;
      });
    },
    onRefundTypeChange() {
      this.form.remark = "";
      this.$nextTick(() => {
        this.$refs.form.validateField("remark");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>